import { Avatar, Box, Flex,  Typography } from "../../../../ppui";

export const headers = (currentPage, rowsPerPage) => [
  {
    key: "slNo",
    label: "SL No.",
    isShortable: true,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "name",
    label: "Employee Name",
    isClickable: true,
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (row) => <>
          <Flex alignItem="center">
            <Avatar
              className={"avatarHover"}
              size="sm"
              initials={`${row.first_name.trim().substring(0, 1).toUpperCase()}${row.last_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
              color="secondary"
              sx={{ marginInlineEnd: "0.625rem" }}
            />
            <Box>
  
              {row.first_name} {row.last_name}
              <br />
              <Typography
                color={"default"}
                colorVariant={"light"}
                variant={"body2"}
                mb={"0"}
              >
                {" "}
                #{row.employee_code}
              </Typography>
            </Box>
          </Flex>
        </>,
  },
  {
    key: "department",
    label: "Department",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.dept_name || "--",
  },
  {
    key: "designation",
    label: "Designation",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.designation_name || "--",
  },
  {
    key: "totalleave",
    label: "Total Leave",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row.total_leaves || "--",
  },
  {
    key: "balanceleave",
    label: "Balance Leave",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) =>
      row.total_leaves && row.used_leaves
        ? row.total_leaves - row.used_leaves
        : "--",
  },
];
